<template>
  <div class="compare__item">
    <AtomsConsumerLoading v-if="!isLoaded" class="compare__select__wrap" />
    <FeaturesHowtochooseRecoverywearSleepitemPartsSearchConditionList
      v-else
      :products="products"
      :selected="conditionSelected"
      :is-show-empty-option="!isCompareBase"
      class="compare__select__wrap"
      @change="onChange"
    />
    <div class="compare__product">
      <AtomsConsumerLoading v-if="!isLoaded" />
      <PagePartsProductListItem
        v-else-if="selectedProduct"
        :product="selectedProduct"
        class="compare__product__item"
        @open-fav-modal="emit('openFavModal', $event, selectedProduct)"
      />
      <div v-else>
        <AtomsConsumerImage
          src="/images/site/feature/howtochoose_recoverywear_sleepitem/blank.svg"
          alt="条件を選択してください"
          :width="412"
          :height="412"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { BakuneTopProduct, SearchConditionSelected } from "~/utils/functions/howtochoose_recoverywear_sleepitem"
import type { PagePartsProductType } from "~/types/product"

const props = defineProps<{
  products: BakuneTopProduct[]
  selected: SearchConditionSelected
  isCompareBase: boolean
}>()

const emit = defineEmits<{
  (e: "change", conditionSelected: SearchConditionSelected): void
  (e: "openFavModal", event: Event, product: PagePartsProductType): void
}>()

const conditionSelected = ref<SearchConditionSelected>({
  sex: "",
  silhouette: "",
  fabric: "",
  sleevesAndPants: "",
  detail: "",
})
const selectedProducts = ref<BakuneTopProduct[]>([])
const isLoaded = ref(false)

const onChange = (payload: {
  searchConditionSelected: SearchConditionSelected
  selectedProducts: BakuneTopProduct[]
}) => {
  conditionSelected.value = payload.searchConditionSelected
  selectedProducts.value = payload.selectedProducts
  isLoaded.value = true
  emit("change", conditionSelected.value)
}

const selectedProduct = computed((): PagePartsProductType | null => {
  return selectedProducts.value.length === 1 ? (selectedProducts.value[0] as PagePartsProductType) : null
})

watch(
  () => props.products,
  () => {
    isLoaded.value = true
  },
)

watch(
  () => props.selected,
  (newSelected) => {
    conditionSelected.value = newSelected
  },
)
</script>

<style scoped lang="scss">
@import "assets/scss/pages/howtochoose_recoverywear_sleepitem/main";
</style>
